import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAKQK2yUYEJtAPARz_LlM22yye9D7oNGqo",
  authDomain: "vishwajeet-khadi.firebaseapp.com",
  projectId: "vishwajeet-khadi",
  storageBucket: "vishwajeet-khadi.firebasestorage.app",
  messagingSenderId: "906770774179",
  appId: "1:906770774179:web:270cc17a7717d1ee28e716"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;